module.exports = __webpack_public_path__ + "static/media/expert-level-icon.png";